/* eslint-disable no-param-reassign */
import {
  getSession,
  setSession,
  getOrderUuidSession,
  deleteSession,
  deleteCoaComplete,
  resetAppState,
} from '../utils/coaPersist';
import {
  SESSION_ACTIVITY_EVENT,
  SESSION_REQUEST_FAILED_EVENT,
  SESSION_REQUEST_STARTED_EVENT,
  SESSION_UNAVAILABLE_EVENT,
  notifySessionUnavailable,
} from '@mgo/core/src/sessionState';

const thirtyMinutes = 1000 * 60 * 30;

export class InactivityRestart {
  timer;

  delay;

  deadline;

  inFlight = 0;

  sessionActive = false;

  constructor(delay, now = () => Date.now()) {
    this.delay = delay;
    this.now = now;
  }

  start() {
    window.addEventListener(SESSION_ACTIVITY_EVENT, this.handleActivity);
    window.addEventListener(SESSION_REQUEST_STARTED_EVENT, this.handleRequestStarted);
    window.addEventListener(SESSION_REQUEST_FAILED_EVENT, this.handleRequestFailed);
    window.addEventListener(SESSION_UNAVAILABLE_EVENT, this.endSession);
  }

  stop() {
    window.removeEventListener(SESSION_ACTIVITY_EVENT, this.handleActivity);
    window.removeEventListener(SESSION_REQUEST_STARTED_EVENT, this.handleRequestStarted);
    window.removeEventListener(SESSION_REQUEST_FAILED_EVENT, this.handleRequestFailed);
    window.removeEventListener(SESSION_UNAVAILABLE_EVENT, this.endSession);
    this.endSession();
  }

  setTimer = () => {
    this.sessionActive = true;
    this.deadline = this.now() + this.delay;
    this.scheduleDeadline();
  };

  handleRequestStarted = () => {
    if (!this.sessionActive) return;

    this.inFlight += 1;
    this.clearTimer();
  };

  handleActivity = () => {
    if (!this.sessionActive) return;

    this.finishRequest();
    this.deadline = this.now() + this.delay;
    this.scheduleDeadline();
  };

  handleRequestFailed = () => {
    if (!this.sessionActive) return;

    this.finishRequest();
    this.scheduleDeadline();
  };

  finishRequest() {
    if (this.inFlight > 0) this.inFlight -= 1;
  }

  scheduleDeadline() {
    this.clearTimer();
    if (!this.sessionActive || this.inFlight > 0 || this.deadline === undefined) return;

    const remaining = this.deadline - this.now();
    if (remaining <= 0) {
      this.expire();
      return;
    }

    this.timer = setTimeout(this.expire, remaining);
  }

  expire = () => {
    this.endSession();
    notifySessionUnavailable();
  };

  endSession = () => {
    this.clearTimer();
    this.deadline = undefined;
    this.inFlight = 0;
    this.sessionActive = false;
  };

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}

export default {
  install(Vue) {
    const restartApplicationTimer = new InactivityRestart(thirtyMinutes);
    restartApplicationTimer.start();
    Vue.prototype.$getSession = getSession;
    Vue.prototype.$getOrderUuidSession = getOrderUuidSession;

    Vue.prototype.$setSession = (uuid, orderUuid) => {
      setSession(uuid, orderUuid);
      restartApplicationTimer.setTimer();
    };

    Vue.prototype.$deleteSession = () => {
      restartApplicationTimer.endSession();
      deleteSession();
      deleteCoaComplete();
    };
    Vue.prototype.$resetAppState = () => {
      resetAppState();
    };
  },
};
